import { observable } from "mobx";
import { AlunoModel } from "../Aluno";


export class MensagemModel {
  @observable public id: number;
  @observable public professorId: number;
  @observable public alunoId: number;
  @observable public texto: string;
  @observable public escritoPor: RemetenteMensagem;
  @observable public lida: boolean;
  @observable public anexos: AnexoModel[];
  @observable public modificadoEm: Date;
  @observable public modificadoPor: string;
  @observable public visualizadoEm?: Date | null;
  @observable public registroDeReuniao: boolean;
  @observable public enviadoEm: Date;
}

export class AnexoModel {
  @observable public id: string;
  @observable public mensagemId: number;
  @observable public arquivo?: File;
  @observable public extensao: TiposDeAnexoValidos;
  @observable public type: string;
}

export class EncontroPresencial {
  @observable public tituloDoEncontro?: string;
  @observable public resumo?: string;
  @observable public dataDoEncontro?: Date;
  @observable public orientacoes?: string;
  @observable public alunoId?: number;
}

type TiposDeAnexoValidos = 'pdf' | 'doc' | 'docx' | 'odt';

export class OrientacaoModel {
  @observable public mensagensPendentes: number;
  @observable public aluno: AlunoModel;
  @observable public ultimaMensagem: MensagemModel;
}

export enum RemetenteMensagem {
  professor,
  aluno
}

export interface PagedRequestAttributes {
  search: string;
  page: number;
  pageSize: number;

}

export class PagedRequest {
  search: string;
  page: number;
  pageSize: number;

  constructor({
    search,
    page,
    pageSize
  }: PagedRequestAttributes) {
    this.search = search;
    this.page = page;
    this.pageSize = pageSize;
  }

  nextPage() {
    this.page++;
    return this;
  }

  previousPage() {
    this.page--;
    return this;
  }

  eval() {
    return ({ search: this.search, page: this.page, pageSize: this.pageSize })
  }
}